<template>
  <div class="logo-oi">
    <div class="logo-img">
      <v-img :src="require('../assets/images/logo_nova_oi_test.png')" width="42"  contain></v-img>
    </div>    
    <div class="logo-text">
      <span class="header--title">CENTRAL DE AJUDA DE ACESSOS</span>
      <!-- <span
        class="header--subtitle d-none d-sm-flex"
      >Diretoria de Tecnologia, Infraestrutura e Segurança da Informação e Cibernética</span>-->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.logo-oi {
  display: flex;
  .logo-img {
    z-index: 10;  
    position: fixed;  
    right: 12px;  
    top: 0;
    padding-top: 22px;
    //margin-right: 200px;
  }
  .logo-text {
    display: flex;
    flex-direction: column;
    padding-top: 12px;
    margin-left: 15px;
    font-family: "Simplon BP Regular", -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol" !important;
    color: #545454 !important;
    .header--title {
      font-size: 22px;
      font-weight: 600;
      text-transform: uppercase;
    }
    .header--subtitle {
      line-height: 4px;
      font-size: 12px;
      color: #545454;
      text-transform: none;
    }
  }
}

@media only screen and (max-width: 400px) {
  .logo-oi .logo-text .header--title {
    font-size: 18px;
  }
  .logo-oi .logo-text {
    padding-top: 14px;
  }
  .logo-oi .logo-img {
    z-index: 10;  
    position: absolute;  
    right: 0;  
    top: 0;
    padding-top: 22px;
    margin-right: 5px;
  }
  
}
</style>
